import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private appQueryParams?: any;

  constructor(
    private http: HttpClient,
    public localStorageService: LocalStorageService
  ) {
    if (this.localStorageService.get('appQueryParams')) {
      this.appQueryParams = JSON.parse(
        this.localStorageService.get('appQueryParams')
      );
    }
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  UserSignUp(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_user_creation;
    input['meta'] = this.appQueryParams;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  AccountVerification(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_account_verification;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  AccountActivation(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_account_activation;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  UserLogin(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_user_login;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  UserLogout(): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_user_logout;
    return this.http
      .post<any>(url, {}, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  socialMediaLogin(input: any): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_social_media_login;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  ValidateLogin(): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_validate_login;
    return this.http
      .post<any>(url, {}, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  VerifyEmail(userId: string): Observable<any> {
    let url =
      environment.prospektr_sell_backend_base_url +
      constants.prospector_verify_email +
      '?userId=' +
      userId;
    return this.http
      .get<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error: { error: { message: string }; status: any; message: any }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
